export default __webpack_public_path__ + "static/media/Stormslash.c15f60f3.jpg";